// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"14ba3423","281":"0f586772","453":"ab29f4d0","924":"5b6788eb"}[chunkId] + ".chunk.js";
};